<template>
  <div v-if="vista && vista.config.paso">
    <div class="grid-container grid-container--6-6">
      <div class="col1">
        <sales-button
          class="button"
          :label="nombreSiguiente"
          @click="adelante"
        />
      </div>
      <div class="col2">
        <div
          class="atras"
          style="margin-bottom: 99px; margin-top: 20px"
          @click="atras"
        >
          <p>Volver</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SalesButton from "@/components/core/SalesButton";

export default {
  name: "StepNavigator",
  components: { SalesButton },
  props: {
    value: Object,
    storeAction: String
  },
  data() {
    return {
      vista: null
    };
  },
  methods: {
    atras() {
      this.$router.go(-1);
    },
    adelante() {
      this.$store.dispatch(this.storeAction, this.value);
    }
  },
  mounted() {
    this.$store.watch(
      this.$store.getters.getRoute,
      route => {
        this.vista = route.meta;
      },
      { immediate: true }
    );
  },
  computed: {
    nombreSiguiente() {
      return this.vista.config.nombreSiguiente || "Continuar";
    }
  }
};
</script>

<style scoped>
div.container {
  margin-top: 20px;
  padding-bottom: 140px;
  display: flex;
  justify-content: space-between;
  height: 56px;
}

p {
  margin-left: 16px;
  font-family: BentonSansBBVA-Medium;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.6;
  letter-spacing: normal;
  color: #237aba;
}

div.atras {
  max-width: 150px;
}

div.atras * {
  display: inline-block;
  vertical-align: middle;
}

div.adelante .button {
  height: auto;
  padding: 0;
  margin: 0;
}

div.container > div {
  cursor: pointer;
}

/* Para dar vuelta los botones */
@media screen and (min-width: 600px) {
  div.container {
    flex-direction: column;
    /* Fix botón que desaparece */
    padding-bottom: 0;
    height: auto;
    min-height: 1px;
  }

  div.atras:nth-child(1) {
    order: 2;
  }

  div.adelante:nth-child(2) {
    order: 1;
    margin-bottom: 27px;
  }

  div.adelante {
    width: 212px;
  }
}
</style>
